var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
import { IconButton } from '@material-ui/core';
import { DeleteOutlined, EditOutlined, FileCopyOutlined, } from '@material-ui/icons';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { AccordionWrapper } from '../../../../../commons/AccordionWrapper';
import { BasicConfigTable } from './components/BasicConfigTable';
import { FNSTable } from './components/FNSTable';
import { PacingTable } from './components/PacingTable';
import { ControlWrapper, FormWrapper, Wrapper } from './SequenceWraper.Styles';
export var SequenceWrapper = function (_a) {
    var index = _a.index, text = _a.text, data = _a.data, onDelete = _a.onDelete, onCopy = _a.onCopy, onEdit = _a.onEdit, isBeingEdited = _a.isBeingEdited, aSequenceIsBeingEdited = _a.aSequenceIsBeingEdited, handleSequenceCallback = _a.handleSequenceCallback, values = _a.values;
    return (React.createElement(Draggable, { draggableId: text, index: index, key: text + index }, function (provided) {
        var _a;
        return (React.createElement(Wrapper, __assign({}, provided.draggableProps, provided.dragHandleProps, { innerRef: provided.innerRef }),
            React.createElement(AccordionWrapper, { name: text },
                React.createElement(FormWrapper, null,
                    ((_a = data.pacing) === null || _a === void 0 ? void 0 : _a.clearPacing) && (React.createElement(AccordionWrapper, { name: 'Pacing' },
                        React.createElement(PacingTable, { data: data.pacing }))),
                    React.createElement(AccordionWrapper, { name: 'Basic Config' },
                        React.createElement(BasicConfigTable, { data: data.basicConfig })),
                    React.createElement(AccordionWrapper, { name: 'Filtering and Sorting' },
                        React.createElement(FNSTable, { data: data.filteringAndSorting })))),
            React.createElement(ControlWrapper, null,
                React.createElement(IconButton, { size: 'small', disabled: isBeingEdited || typeof aSequenceIsBeingEdited[1] === 'number' },
                    React.createElement(EditOutlined, { fontSize: 'small', onClick: function () {
                            handleSequenceCallback(true);
                            onEdit(index, JSON.parse(JSON.stringify(data)));
                        } })),
                React.createElement(IconButton, { size: 'small', disabled: isBeingEdited || typeof aSequenceIsBeingEdited[1] === 'number', onClick: function () { return onDelete(index); } },
                    React.createElement(DeleteOutlined, { fontSize: 'small' })),
                React.createElement(IconButton, { size: 'small', disabled: isBeingEdited || typeof aSequenceIsBeingEdited[1] === 'number', onClick: function () {
                        return onCopy(__assign(__assign({}, data), { sequenceName: data.sequenceName + " - Copy" }));
                    } },
                    React.createElement(FileCopyOutlined, { fontSize: 'small' })))));
    }));
};
SequenceWrapper.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=SequenceWrapper.js.map